import { render, staticRenderFns } from "./PreProjectsPhoneList.vue?vue&type=template&id=2a5c6364"
import script from "./PreProjectsPhoneList.vue?vue&type=script&lang=js"
export * from "./PreProjectsPhoneList.vue?vue&type=script&lang=js"
import style0 from "./PreProjectsPhoneList.vue?vue&type=style&index=0&id=2a5c6364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports